import React from "react";
import SimpleContainer from "components/shared/SimpleContainer";

class EmbeddableContent extends React.Component {
  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
    this.resizeEmbeds = this.resizeEmbeds.bind(this);
  }

  componentDidMount() {
    this.resizeEmbeds();
    window.addEventListener("resize", this.resizeEmbeds);
  }

  componentDidUpdate() {
    this.resizeEmbeds();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeEmbeds);
  }

  resizeEmbeds() {
    const container = this.contentRef.current;
    if (!container) return;

    container.querySelectorAll("iframe").forEach((iframe) => {
      const originalWidth = parseFloat(iframe.getAttribute("width"));
      const originalHeight = parseFloat(iframe.getAttribute("height"));

      iframe.style.maxWidth = "100%";
      iframe.style.border = iframe.style.border || "0";

      if (originalWidth > 0 && originalHeight > 0) {
        const availableWidth = container.clientWidth;
        const renderedWidth = Math.min(originalWidth, availableWidth);

        iframe.style.width = `${renderedWidth}px`;
        iframe.style.height = `${renderedWidth * (originalHeight / originalWidth)}px`;
        iframe.style.display = "block";
      } else {
        iframe.style.width = "100%";
      }
    });
  }

  render() {
    const { title, title_color, body, icon } = this.props;
    const decodedBody = body
      .replace(/\$amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'");

    return (
      <SimpleContainer color={title_color} title={title} icon={icon}>
        <div
          ref={this.contentRef}
          className="embeddable-content m-top-1"
          style={{ clear: "both" }}
          dangerouslySetInnerHTML={{ __html: decodedBody }}
        />
      </SimpleContainer>
    );
  }
}

export default EmbeddableContent;
